/**
 * Transform PHP product data to frontend format
 *
 * @since 1.0.0
 */

import type { RedFoxCartProduct } from '@/frontend/types/cart';

import type { PhpProductData } from '../types';

/**
 * Transform PHP product data to frontend format
 *
 * @param phpProduct - Product data from PHP
 */
export const transformPhpProduct = (phpProduct: Record<string, unknown>): RedFoxCartProduct => {
  const typedProduct = phpProduct as PhpProductData;

  return {
    name: String(typedProduct.name ?? 'Unknown Product'),
    regular_price: parseFloat(String(typedProduct.regular_price ?? 0)) || 0,
    sale_price: parseFloat(String(typedProduct.sale_price ?? 0)) || 0,
    formatted_price: String(typedProduct.formatted_price ?? '$0.00'),
    quantity: parseInt(String(typedProduct.quantity ?? 1), 10) || 1,
    image_url: String(typedProduct.image_url ?? ''),
    image_alt: String(typedProduct.image_alt ?? typedProduct.name ?? ''),
    is_on_sale: Boolean(typedProduct.is_on_sale),
    is_variation: Boolean(typedProduct.is_variation),
    variation_data:
      (typedProduct.variation_data as RedFoxCartProduct['variation_data']) ?? undefined,
  };
};
